export const load = () => ({
	title: 'DIY Window Treatments: No Contractors Required',
	showTitle: true,
});
